import { createSlice } from "@reduxjs/toolkit";

const initialDocumentTemplateSlice = {
  page: null,
  limit: null,
  documents: [],
  totalPages: null,
  listLoading: false,
  totalResults: null,
  actionLoading: false,
};

export const documentTemplateSlice = createSlice({
  name: "documentTemplateSlice",
  initialState: initialDocumentTemplateSlice,
  reducers: {
    startCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    stopCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    getAllDocuments: (state, action) => {
      const { results, totalPages, totalResults, limit, page } = action.payload.document;
      state.documents = results;
      state.limit = limit;
      state.page = page;
      state.totalPages = totalPages;
      state.totalResults = totalResults;
      state.listLoading = false;
    },
  },
});
